import { Link } from "react-router-dom";
import { categories, site } from "@/mocks/content";

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 font-heading text-lg font-black text-foreground-900">
                瓜
              </span>
              <span className="font-heading text-xl font-black text-background-50">
                今日新瓜
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-200/90">
              {site.desc}
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-wechat-fill", "ri-message-3-fill", "ri-send-plane-fill"].map(
                (ic, i) => (
                  <a
                    key={ic}
                    href="#/"
                    aria-label="社交平台"
                    className={`flex h-9 w-9 items-center justify-center rounded-full border border-background-100/20 text-background-200 transition-colors hover:bg-accent-500 hover:text-foreground-900 ${
                      i === 0 ? "" : ""
                    }`}
                  >
                    <i className={ic} />
                  </a>
                ),
              )}
            </div>
          </div>

          <div>
            <h4 className="mb-4 flex items-center gap-2 text-sm font-semibold text-background-50">
              <i className="ri-grid-fill text-accent-400" />
              热门栏目
            </h4>
            <ul className="space-y-2.5">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/category/${c.slug}`}
                    className="inline-flex items-center gap-2 text-sm text-background-200/90 transition-colors hover:text-accent-300"
                  >
                    <i className={`${c.icon} text-[12px]`} />
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 flex items-center gap-2 text-sm font-semibold text-background-50">
              <i className="ri-links-fill text-accent-400" />
              快捷入口
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-background-200/90 transition-colors hover:text-accent-300">
                  网站首页
                </Link>
              </li>
              <li>
                <Link to="/category/exclusive" className="text-background-200/90 transition-colors hover:text-accent-300">
                  独家内幕专区
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-200/90 transition-colors hover:text-accent-300">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-background-200/90 transition-colors hover:text-accent-300">
                  常见问题
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 flex items-center gap-2 text-sm font-semibold text-background-50">
              <i className="ri-mail-fill text-accent-400" />
              联系我们
            </h4>
            <p className="text-sm leading-relaxed text-background-200/90">
              有独家线索或纠错反馈？欢迎发信给编辑部。
            </p>
            <a
              href={`mailto:${site.email}`}
              className="mt-3 inline-flex items-center gap-2 break-all text-sm font-medium text-accent-300 hover:text-accent-200"
            >
              <i className="ri-mail-send-line" />
              {site.email}
            </a>
            <div className="mt-4 rounded-lg border border-background-100/15 bg-background-100/5 p-3">
              <p className="text-xs leading-relaxed text-background-200/70">
                <i className="ri-information-fill mr-1 text-accent-400" />
                {site.notice}
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-100/15 pt-6 sm:flex-row">
          <p className="text-xs text-background-200/70">
            © {new Date().getFullYear()} 今日新瓜 · 专注文娱独家内幕与深度吃瓜
          </p>
          <p className="text-xs text-background-200/50">
            理性吃瓜 · 拒绝造谣 · 尊重原创
          </p>
        </div>
      </div>
    </footer>
  );
}